export default class SecondNavigation {

    constructor(el, setting) {
        this.$el = el;
        this.renderDropdowns(this.$el);
    }

    renderDropdowns(el) {
        if (el) {
            const navigation = el.querySelector(".breadcrumb").children;
            let childrenItems = [];
            let childrenItemsByParent;
            for (let i = 0; i < navigation.length; i++) {
                let item = navigation[i];

                item.querySelector('a') ? item.querySelector('a').classList.contains('active') ? this.setPrimaryMenuActiveElement(item) : false : false;
                let itemHasParent = item.dataset.parent ? true : false;
                itemHasParent ? childrenItems.push({ parent: item.dataset.parent, item }) : false;
                let itemHref = navigation[i].querySelector('a') ? navigation[i].querySelector('a').href : navigation[i].dataset.href;
                itemHref ? this.setActiveItem({ url: itemHref, item: navigation[i] }) : false;
            }

            for (let i = 0; i < navigation.length; i++) {
                let item = navigation[i];
                childrenItemsByParent = childrenItems.filter(function(e) { return e.parent === item.dataset.item });
                this.appendChildItems(childrenItemsByParent);
            }
        }
    }

    setPrimaryMenuActiveElement(item) {
        let activeItem = 'menu-item-' + item.dataset.parent;
        //console.log(activeItem);
        let primaryMenu = document.querySelector('.navbar-nav');
        let primaryMenuItems = primaryMenu.children;
        for (let index = 0; index < primaryMenuItems.length; index++) {
            const element = primaryMenuItems[index];
            element.id == activeItem ? element.classList.add('active') : false;
        }

    }

    appendChildItems(el, childrenItems) {

        if (el.length) {
            let paretnWrap = this.getTarget(el[0].parent);
            let currentDropDownWarp;
            let dropDownWarp = document.createElement('div');
            dropDownWarp.className = 'dropdown-content';

            for (let i = 0; i < paretnWrap.length; i++) {
                currentDropDownWarp = paretnWrap[i].appendChild(dropDownWarp);
                paretnWrap[i].classList.add('dropdown');

                let navigation = this.$el.querySelector(".breadcrumb").children;
                for (let k = 0; k < navigation.length; k++) {
                    if (paretnWrap[i].dataset.item == navigation[k].dataset.parent) {

                        let currentDropDownWarp = paretnWrap[i].querySelector('.dropdown-content');
                        let newItem = document.createElement('a');
                        newItem.setAttribute('href', navigation[k].dataset.href);
                        newItem.setAttribute('class', navigation[k].dataset.active);
                        newItem.innerHTML = navigation[k].innerHTML;
                        currentDropDownWarp.appendChild(newItem);
                        if (navigation[k].dataset.active) {
                            paretnWrap[i].querySelector('a').classList.add('active');
                        }
                    }
                }
            }

        }

    }

    getTarget(target) {
        const navigation = this.$el.querySelector(".breadcrumb").children;
        let arrays = [];
        for (let i = 0; i < navigation.length; i++) {
            let item = navigation[i];
            let hasTarget = item.dataset.item ? true : false;
            item.dataset.item == target ? arrays.push(navigation[i]) : false;
        }
        return arrays;
    }

    setActiveItem(url) {
        const currentUrl = window.location.href;
        Object.keys(url).forEach(function(k, item) {
            if (url.url == window.location.href) {
                let item = url[k];
            }
        });
    }

}
